/**
 * `/$org/apps/imanage/`: the workspaces of the chosen library (`?lib=`).
 *
 * @module routes/$org.apps.imanage.index
 */
import { createFileRoute } from "@tanstack/react-router";

import { IManageHomePage } from "../components/apps/imanage/IManagePages";
import { parseIManageSearch } from "../components/apps/imanage/imanagePaths";

function IManageHomeRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <IManageHomePage
      search={search}
      onSearchChange={(next, options) => void navigate({ search: next, replace: options?.replace ?? false })}
    />
  );
}

export const Route = createFileRoute("/$org/apps/imanage/")({
  validateSearch: parseIManageSearch,
  component: IManageHomeRoute,
});
